import React from 'react'

import { IBaseProps } from 'browser/components/atomic-elements/atoms/base-props'
import { ButtonGroupSelect } from 'browser/components/atomic-elements/atoms/select/button-group-select/button-group-select'

interface INegatableFilter {
  isNegation?: boolean
}

export interface INegatableFilterProps<T extends INegatableFilter> extends IBaseProps {
  filter: T
  onChange: (value: T, isNegationToggle: boolean) => void
}

export class NegatableFilter<T extends INegatableFilter> extends React.Component<
  INegatableFilterProps<T>,
  any
> {
  private handleNegationChange = (isNegation: boolean) => {
    const { filter } = this.props
    filter['isNegation'] = isNegation
    this.props.onChange(filter, true)
  }

  public render() {
    const { filter } = this.props

    const negationOptions = [
      {
        label: 'Include',
        value: false,
      },
      {
        label: 'Exclude',
        value: true,
      },
    ]

    return (
      <ButtonGroupSelect
        onChange={this.handleNegationChange}
        options={negationOptions}
        value={filter['isNegation'] || false}
      />
    )
  }
}
